module.exports = __webpack_public_path__ + "static/media/Q3-7.df32a9c5.jpg";